export enum ContractActualPeriod {
    capAny = 0,
    capDay = 1,
    capWeek = 2,
    capMonth = 3,
    capQuarter = 4,
    capSixMonth = 5,
    capYear = 6,
    capAllPeriod = 7
}